import $http from "../axios";

const state = {
  operators: []
};

const getters = {
  operators: state => {
    return state.operators;
  }
};

const actions = {
  getOperators({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`operators`)
        .then(res => {
          if (res.data.result === "ok" && res.data.payload.operators) {
            commit("SET_OPERATORS", res.data.payload.operators);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  createOperator({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`create-operator`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("ADD_OPERATOR", res.data.payload.newOperator);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateOperator({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-operator`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_OPERATOR", data.operator);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  changeOperatorStatus(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-operator-status`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_OPERATORS(state, operators) {
    state.operators = operators;
  },

  ADD_OPERATOR(state, operator) {
    state.operators.push(operator);
  },

  UPDATE_OPERATOR(state, operator) {
    const index = state.operators.findIndex(o => {
      return o._id.toString() === operator._id.toString();
    });

    if (index > -1) {
      state.operators[index].permissions = operator.permissions;
      state.operators[index].perosnalInfo = operator.perosnalInfo;
    }
  },

  REMOVE_OPERATOR(state, operatorId) {
    state.operators = state.operators.filter(o => {
      return o._id !== operatorId;
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
